import { render, staticRenderFns } from "./BiltyInfo.vue?vue&type=template&id=2339f784&"
import script from "./BiltyInfo.vue?vue&type=script&lang=js&"
export * from "./BiltyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports